import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { data } from "../data";
import { Label, Wrapper } from "../Panel";import { Dropdown } from "./helpers/constants";

import { onChange } from "./helpers/on-change"
import { gridContainers } from "../../helpers/handleContainers";

const DEFAULT_GRID: string = "properties.styles.$deviceType.gridCols";
const DEFAULT_GRID_ROWS: string = "properties.styles.$deviceType.gridRows";
const DEFAULT_SPAN: string = "properties.styles.$deviceType.span";
const DEFAULT_ROW_SPAN: string = "properties.styles.$deviceType.rowSpan";
const DEFAULT_GRID_GAP: string = "properties.styles.$deviceType.gap";

type Props = {
  label?: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const GridCols = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_GRID.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_GRID.split("."), deviceType)]);

  return (
    <Wrapper>
      <Label id="gridCols" label="Grid" />
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={data.cols.map(el => ({ name: el.label }))}
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.cols) {
            const item = data.cols.find(item => item.label === option.name)
            if (item) {
              const value = item.value;
              setValue(value)
              onChange({
                path: DEFAULT_GRID,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }
        }
      />
    </Wrapper>
  )
};
export const GridRows = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_GRID_ROWS.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_GRID_ROWS.split("."), deviceType)]);

  return (
    <Wrapper>
      <Label id="gridRows" label="Grid Row" />
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={data.rows.map(el => ({ name: el.label }))}
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.rows) {
            const item = data.rows.find(item => item.label === option.name)
            if (item) {
              const value = item.value;
              setValue(value)
              onChange({
                path: DEFAULT_GRID_ROWS,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }
        }
      />
    </Wrapper>
  )
};
export const Span = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, gridStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState<any>(defaultValue);
  const component = components[selectedElementId];
  const {parentId} = component;
  const parentComponent = parentId && components[component.parentId]
  const isParentGrid = parentComponent ? gridContainers.includes(parentComponent.type) : gridStyles[deviceType].layout === "Grid"

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_SPAN.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_SPAN.split("."), deviceType)]);

  useEffect(() => {
    if (!defaultValue) {
      if(deviceType === "Sm") {
        setValue("1")
      } else if (deviceType === "Md") {
        setValue("6")
      } else {
        setValue("12")
      }
    }
  }, [defaultValue, deviceType])

  if (!isParentGrid) {
    return null
  }

  return (
    <Wrapper>
      <Label id="span" label="Span" />
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={data.gridSpan.map(el => ({ name: el.label }))}
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.gridSpan) {
            const item = data.gridSpan.find(item => item.label === option.name)
            if (item) {
              const value = item.value;
              setValue(value)
              onChange({
                path: DEFAULT_SPAN,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }
        }
      />
    </Wrapper>
  )
};
export const RowSpan = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, gridStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];
  const {parentId} = component;
  const parentComponent = parentId && components[component.parentId]
  const isParentGrid = parentComponent ? gridContainers.includes(parentComponent.type) : gridStyles[deviceType].layout === "Grid"

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_ROW_SPAN.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_ROW_SPAN.split("."), deviceType)]);

  if (!isParentGrid) {
    return null
  }

  return (
    <Wrapper>
      <Label id="rowSpan" label="Row Span" />
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={data.gridSpan.map(el => ({ name: el.label }))}
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.gridSpan) {
            const item = data.gridSpan.find(item => item.label === option.name)
            if (item) {
              const value = item.value;
              setValue(value)
              onChange({
                path: DEFAULT_ROW_SPAN,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }
        }
      />
    </Wrapper>
  )
};

export const GridGap = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_GRID_GAP.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_GRID_GAP.split("."), deviceType) ?? 0]);

  return (
    <div className="panel-div">
      <label
        htmlFor="gap"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto", fontSize: "12px", color: "#282B31",height:"28px",borderRadius:"2px", paddingTop: "7px", }}
        disabled={!isCheckedIn}
        type="number"
        min="0"
        id="gap"
        value={value}
        className="panel-input"
        placeholder="0"
        onChange={e => {
          const changeValue = e.target.value;
          const value = changeValue ? Number(changeValue) > 0 ? changeValue: "0": changeValue;
          setValue(value, () => onChange({
            path: DEFAULT_GRID_GAP,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
};